import { Flux } from "@/savaradio/common"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: {
  value: { audio?: boolean, video?: boolean },
  metadata?: { audio?: string, video?: string },
  expand: { audio: boolean, video: boolean },
  drag: { audio: boolean, video: boolean },
  pos: { audio: { x: number, y: number }, video: { x: number, y: number } },
  flux: Flux | null
} = {
  value: {},
  expand: { audio: false, video: false },
  drag: { audio: false, video: false },
  pos: { audio: { x: 0, y: 0 }, video: { x: 0, y: 0 } },
  flux: null
}

const liveSlice = createSlice({
  initialState,
  name: "live_slice",
  reducers: {
    set_video: (state, action: PayloadAction<boolean>) => {
      state.value.video = action.payload
    },
    set_audio: (state, action: PayloadAction<boolean>) => {
      state.value.audio = action.payload
    },
    reset: (state, action: PayloadAction<typeof initialState.value>) => {
      state.value = action.payload
    },
    reset_metadata: (state, action: PayloadAction<Partial<Record<"video" | "audio", string>>>) => {
      state.metadata = {
        ...state.metadata,
        ...action.payload
      }
    },
    reset_expand: (state, action: PayloadAction<Partial<Record<"video" | "audio", boolean>>>) => {
      state.expand = {
        ...state.expand,
        ...action.payload
      }
    },
    reset_drag: (state, action: PayloadAction<Partial<Record<"video" | "audio", boolean>>>) => {
      state.drag = {
        ...state.drag, ...action.payload
      }
    },
    setPos: (state, action: PayloadAction<Partial<Record<"video" | "audio", { x: number, y: number }>>>) => {
      state.pos = {
        ...state.pos, ...action.payload
      }
    },
    set_flux: (state, action: PayloadAction<Flux | null>) => {
      state.flux = action.payload
    }
  }
})

export const { reset, reset_metadata, reset_expand, reset_drag, setPos, set_flux, set_video, set_audio } = liveSlice.actions

export const live_slice = liveSlice.reducer